import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import { Device, from, until } from '@helpers/media';
import { h3, paragraph } from '@helpers/typography';
import { ButtonStyles } from '@stories/Components/Buttons/GeneralButton/Button.styles';
import Controls from '@stories/Components/Carousels/Carousel/Controls/Controls';
import MotionTrack from '@stories/Components/Carousels/Carousel/MotionTrack/MotionTrack';
import SectionWrapper from '@stories/Components/Global/SectionWrapper/SectionWrapper';
import SectionWrapperStyles from '@stories/Components/Global/SectionWrapper/SectionWrapper.styles';
import styled from 'styled-components';
const Container = styled(SectionWrapper) `
  --bgColor: transparent;
  --fgColor: ${brand.black};
  --itemGutter: 24px;
  --visibleItems: 1;

  color: var(--fgColor);
  margin-top: ${fluid(40, 80)};
  margin-bottom: ${fluid(40, 80)};
  overflow: clip;

  @media ${from(Device.TabletLarge)} {
    --visibleItems: 2;
  }

  @media ${from(Device.DesktopSmall)} {
    --itemGutter: 40px;
  }

  ${SectionWrapperStyles.SiteWide} > ${ButtonStyles.Button} {
    margin: 20px 0;

    @media ${from(Device.TabletLarge)} {
      display: none;
    }
  }

  .card-area {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: var(--itemGutter);
  }
`;
const Track = styled(MotionTrack) `
  margin-top: 3rem;
  overflow: hidden;
`;
const TitleArea = styled.div `
  display: flex;
  align-items: center;
  justify-content: space-between;

  @media ${until(Device.TabletLarge)} {
    ${ButtonStyles.Button} {
      display: none;
    }
  }
`;
const Title = styled.h2 `
  ${h3};
  margin-bottom: 0;
`;
const Content = styled.div `
  ${paragraph};
  margin-top: 1rem;
  margin-bottom: 0;
  max-width: 65ch;
`;
const Item = styled.li `
  display: block;
  flex: 0 0 calc(100% / var(--visibleItems));
  padding-right: var(--itemGutter);
`;
const PaginationWrapper = styled.div `
  margin: 2rem 0 0;
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  gap: 0.5rem;
  align-items: center;
`;
const Pagination = styled.div `
  grid-column: span 9;

  @media ${from(Device.TabletLarge)} {
    grid-column: 3 / span 8;
  }
`;
const TestButtonContainer = styled.div `
  text-align: center;
  padding-bottom: 12px;
`;
const StyledControls = styled(Controls) `
  grid-column: 10 / span 3;
  justify-self: end;
  display: flex;
  gap: 0.5rem;

  @media ${from(Device.TabletLarge)} {
    grid-column: 11 / span 2;
  }
`;
const Button = styled.button `
  display: flex;
  align-items: center;
  justify-content: center;
  width: 41px;
  height: 41px;
  background-color: ${brand.black};
  border: none;
  border-radius: 5000000px;
  color: ${brand.white};
  transition: background-color 0.3s;

  &:disabled {
    opacity: 0.5;

    &:hover {
      background-color: ${brand.black};
      opacity: 0.5;
    }
  }

  &:hover {
    background-color: ${brand.grey.grey40};
  }

  svg {
    height: 15px;
  }
`;
const TestimonialsStyles = {
    Button,
    Container,
    Content,
    Controls: StyledControls,
    Item,
    Pagination,
    PaginationWrapper,
    Title,
    TitleArea,
    Track,
    TestButtonContainer,
};
export default TestimonialsStyles;
